import StopwatchIcon from '@atlaskit/icon/core/stopwatch';
import * as React from 'react';

export function SvgTimer() {
  return <StopwatchIcon label="" testId="ads-refreshed-icon" />;
}
